import React, { useContext } from "react";
import MobileNav from "../MobileNav/MobileNav";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar/Sidebar";
import beforeIcon from "../../icons/beforeIcon.svg";
import companyIcon from "../../icons/companyIcon.svg";
import faqIcon from "../../icons/faqIcon.svg";
import financeIcon from "../../icons/financeIcon.svg";
import glossaryIcon from "../../icons/glossaryIcon.svg";
import homeIcon from "../../icons/homeIcon.svg";
import questionnaireIcon from "../../icons/questionnaireIcon.svg";
import reportIcon from "../../icons/reportIcon.svg";
import styled from "styled-components";
import uploadIcon from "../../icons/uploadIcon.svg";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { UserData } from "../../context";

const Layout = (props) => {
  const { product = {}, children } = props;
  const user = useContext(UserData) || {};

  const { ica, stratPlan } = user.config || {};
  // const connectCriteriaCompleted = (user.config
  //   && user.config.progresses
  //   && user.config.progresses.portalCriteria
  //   && user.config.progresses.portalCriteria === 'completed') || false

  // const content = (user.config
  // && user.config.progresses
  // && user.config.progresses.content) || ""

  // const connectContentCompleted = content === 'inReview' || content === 'approved'

  const isMobile = useMediaQuery(768);
  let navItemsList = [
  ];

  if (product === "portal" || product === "home") {
    navItemsList = navItemsList.concat([
      { title: "Home", link: "/portal", icon: financeIcon },
      { title: "Compose Page", link: "/content", icon: financeIcon },
      { title: "Upload Files", link: "/portal-upload", icon: uploadIcon },
      { title: "Specify Criteria", link: "/criteria", icon: financeIcon },
      { title: "Source Of Funds", link: "/search-sof", icon: financeIcon },
      { title: "Messages", link: "/recent-messages", icon: financeIcon },
    ]);

    if (user.config === undefined || ica === true) {
      navItemsList = navItemsList.concat([
        { title: "Intro Analysis", link: "/progress", exact: true, icon: homeIcon }
      ])
    }
    if (stratPlan) {
      navItemsList = navItemsList.concat([
        { title: "Strat Plan", link: "/company-stratplan", exact: true, icon: homeIcon, }
      ])
    }
    navItemsList = navItemsList.concat([
      { title: "FAQ", link: "/portal-faq", icon: glossaryIcon },
    ]);
  } else if (product === "ica") {
    navItemsList = navItemsList.concat([
      { title: "DreamEx Connect", link: "/portal", icon: financeIcon },
      { title: "Before You Start", link: "/info", icon: beforeIcon },
      { title: "Company", link: "/company", icon: companyIcon },
      { title: "Upload", link: "/upload", icon: uploadIcon },
      { title: "Questionnaire", link: "/questionnaire", icon: questionnaireIcon, },
      { title: "Report", link: "/report", icon: reportIcon },
      { title: "FAQ", link: "/faq", icon: faqIcon },
      { title: "Glossary", link: "/ica-glossary", icon: glossaryIcon },
    ]);
  } else if (product === "stratPlan") {
    navItemsList = navItemsList.concat([
      { title: "DreamEx Connect", link: "/portal", icon: financeIcon },
      { title: "Company", link: "/company-stratplan", icon: companyIcon },
      { title: "Financial", link: "/financial", icon: financeIcon },
      { title: "Current Scene", link: "/questionnaire-stratplan", icon: financeIcon },
      { title: "Glossary", link: "/financial-glossary", icon: glossaryIcon },
    ]);
  }

  return (
    <div>
      {isMobile ? (
        <MobileNav navItems={navItemsList} />
      ) : (
        <>
          <Navbar />
          <Sidebar navItems={navItemsList} />
        </>
      )}
      <Main isMobile={isMobile}>{children}</Main>
    </div>
  );
};

const Main = styled.div`
  margin-left: ${({ isMobile }) => (isMobile ? "0px" : "190px")};
  position: relative;
  margin-top: 50px;
`;

export default Layout;
